export const IMAGE_URL = {
  logo: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/website/pp-logo-yellow-cap.png',
  phone: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/website/phone.png',
  whatsapp: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/website/whatsapp.png',
  indonasia: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/website/flag_indonesia.png',
  english: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/website/flag_eng.png'
}
